import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PartialToast, Toast } from '@stylehaven/components';
import { RecordService } from '../../record/services/record.service';
import { ToastService } from '../../toast/service/toast.service';
import { PrintService } from '../services/print.service';

@Injectable()
export class LabelPrintSandboxService {
    constructor(
        private recordService: RecordService,
        private printService: PrintService,
        private toastService: ToastService
    ) {}

    qr(recordId: string, params: any): Observable<Blob> {
        return this.recordService.getQRCode(recordId, params);
    }

    print(element: HTMLElement): Observable<boolean> {
        return this.printService.print(element);
    }

    createToast(toast: Toast): void {
        this.toastService.add(toast);
    }

    updateToast(id: number, toast: PartialToast): void {
        this.toastService.update(id, toast);
    }

    deleteToast(id: number): void {
        this.toastService.delete(id);
    }
}
